import { Spinner } from "flowbite-react";

const SpinnerCustom = ({ className="" }) => (
  <div className={`flex items-center justify-center ${className}`}>
    <Spinner color="info" size="md" />
  </div>
);

export default SpinnerCustom;
